import React, { Fragment, Component } from "react";
import { withRouter } from "react-router";
import {
  Col,
  Container,
  Row,
  Spinner,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import IndexBloc from "../../Blocs/IndexBloc";
import { Line } from "react-chartjs-2";
import apiResponse from "../../../../../../services/apiResponse";
import {
  Document,
  Packer,
  Paragraph,
  ImageRun,
  TextRun,
  AlignmentType,
} from "docx";
import { saveAs } from "file-saver";
import image from "../../../../../../assets/images/BKPM NEW 1.png";

class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      data: null,
      loading: false,
      hoveredDesc: false,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({ loading: true, errorMessage: null });

    this.indexBloc.getGraphSystemLoad6HourChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          let errormessage = result.data.message;
          this.setState({
            data: response,
            loading: false,
            errorMessage: errormessage,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            errorMessage: "Failed to load data. Please try again.",
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchGraphSystemLoad6Hour({});
  };

  createChart = () => {
    const { selectedHost } = this.props;
    const { data } = this.state;

    const defaultChartData = {
      labels: [],
      datasets: [],
    };

    if (!selectedHost) {
      return defaultChartData;
    }

    const value = selectedHost.value;

    const specificHost = Array.isArray(data)
      ? data.find((item) => item.host.hostid === value)
      : null;

    const graphId = specificHost ? specificHost.graph.graphid : null;

    const specificGraph = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.graph.graphid === graphId)
      : null;

    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const filteredItems = items.filter(
      (item) => item.name !== "Linux: Number of CPUs"
    );

    const datasets = filteredItems.map((item, index) => {
      const dataPoints = item.values.map((value) => parseFloat(value.last));

      return {
        label: item.name,
        data: dataPoints,
        borderColor: this.getColorForItem(index),
        backgroundColor: this.getColorForItem(index),
        fill: false,
        tension: 0.1,
      };
    });

    const labels =
      filteredItems.length > 0 && filteredItems[0].values
        ? filteredItems[0].values.map((value) => value.timestamp)
        : [];

    return {
      labels: labels,
      datasets: datasets,
    };
  };

  getColorForItem = (index) => {
    const colors = [
      "rgba(0, 130, 0, 0.8)",
      "rgba(214, 68, 0, 0.8)",
      "rgba(0, 238, 0, 0.8)",
      "rgba(255, 176, 0, 0.8)",
      "rgba(255, 24, 169, 0.8)",
    ];
    return colors[index % colors.length];
  };

  renderSystemLoadInfo = () => {
    const { selectedHost } = this.props;
    const { data } = this.state;

    if (!selectedHost) {
      return <div>Tidak ada host yang dipilih.</div>;
    }

    const value = selectedHost.value;

    const specificHost = Array.isArray(data)
      ? data.find((item) => item.host.hostid === value)
      : null;

    const graphId = specificHost ? specificHost.graph.graphid : null;

    const specificGraph = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.graph.graphid === graphId)
      : null;

    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const filteredItems = items.filter(
      (item) => item.name !== "Linux: Number of CPUs"
    );

    if (filteredItems.length === 0) {
      return <div>Tidak ada informasi tersedia untuk host yang dipilih.</div>;
    }

    return (
      <div>
        <div>
          <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            Informasi{" "}
            <span
              className="uil-info-circle"
              onMouseEnter={() => this.setState({ hoveredDesc: true })}
              onMouseLeave={() => this.setState({ hoveredDesc: false })}
              style={{ cursor: "pointer" }}
            />
          </div>
          <br />
        </div>
        {this.state.hoveredDesc && (
          <div
            style={{
              position: "absolute",
              background: "#f4f4f4",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "10px",
              zIndex: 1000,
              width: "900px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            {this.renderDescDescriptions()}
          </div>
        )}

        {filteredItems.map((item, index) => (
          <div key={index}>
            <strong>{item.name}</strong> : <strong>Last:</strong>{" "}
            {item.last !== null ? item.last : "0.000"}% <strong>|</strong>{" "}
            <strong>Min:</strong> {item.min !== null ? item.min : "0.000"}%{" "}
            <strong>|</strong> <strong>Average:</strong>{" "}
            {item.average !== null ? item.average : "0.000"}% <strong>|</strong>{" "}
            <strong>Max:</strong> {item.max !== null ? item.max : "0.000"}%
          </div>
        ))}
      </div>
    );
  };

  renderDescDescriptions = () => {
    const desc = [
      {
        level: "Load average (1m avg)",
        description:
          "Menunjukkan beban rata-rata dari sistem dalam 1 menit terakhir.",
      },
      {
        level: "Load average (5m avg)",
        description:
          "Menunjukkan beban rata-rata dari sistem selama 5 menit terakhir.",
      },
      {
        level: "Load average (15m avg)",
        description:
          "Menunjukkan beban rata-rata dari sistem selama 15 menit terakhir.",
      },
    ];

    return (
      <div>
        {desc.map((item, index) => (
          <div key={index}>
            <strong>{item.level}:</strong> {item.description}
          </div>
        ))}
      </div>
    );
  };

  handleDownloadWord = () => {
    const chartInstance = this.chartRef;

    if (!chartInstance) {
      console.error("Chart instance not found.");
      return;
    }

    const imgData = chartInstance.toBase64Image();

    const { selectedHost } = this.props;
    const value = selectedHost.label;

    const currentDate = new Date();
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedDate = currentDate.toLocaleDateString("id-ID", options);

    const chartData = this.createChart();
    const analysisResults = this.analyzeChartData(chartData.datasets);

    const analysisParagraphs = analysisResults.map(
      (result) =>
        new Paragraph({
          spacing: { after: 80 },
          children: [
            new TextRun({
              text: `Grafik ${result.label}: Rata-rata ${result.average}% (`,
              font: "Arial",
              size: 20,
            }),
            new TextRun({
              text: result.status,
              font: "Arial",
              size: 20,
              bold: true,
            }),
            new TextRun({
              text: `)`,
              font: "Arial",
              size: 20,
            }),
          ],
        })
    );

    let paragraphText;
    if (this.allGood(analysisResults)) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Sistem tidak hanya stabil tetapi juga memiliki kapasitas yang cukup untuk menangani tambahan proses jika diperlukan.";
    } else if (this.allFair(analysisResults)) {
      paragraphText =
        "Jika nilai rata-rata load average berada dalam Kondisi Fair menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Dalam kondisi ini, load average sudah mendekati kapasitas maksimum, sehingga sistem memiliki risiko menjadi terlalu terbebani jika ada tambahan proses yang signifikan.";
    } else if (this.allWarning(analysisResults)) {
      paragraphText =
        "Jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius.";
    } else if (this.allBad(analysisResults)) {
      paragraphText =
        "Jika nilai rata-rata load average berada dalam kondisi Bad, ini menunjukkan bahwa sistem mengalami beban berlebih yang signifikan, di mana jumlah proses yang menunggu untuk dijalankan oleh CPU jauh melebihi kapasitas yang tersedia. Hal ini biasanya disebabkan oleh jumlah tugas yang terlalu banyak untuk ditangani secara efisien oleh CPU.";
    } else if (
      this.someFair(analysisResults) &&
      this.someIdle(analysisResults)
    ) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Tetapi, Jika nilai rata-rata load average berada dalam Kondisi Fair menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Dalam kondisi ini, load average sudah mendekati kapasitas maksimum, sehingga sistem memiliki risiko menjadi terlalu terbebani jika ada tambahan proses yang signifikan.";
    } else if (
      this.someWarning(analysisResults) &&
      this.someIdle(analysisResults)
    ) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Tetapi, Jika nilai rata-rata load average berada dalam Kondisi Warning menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Tetapi, jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius.";
    } else if (
      this.someBad(analysisResults) &&
      this.someIdle(analysisResults)
    ) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Sistem tidak hanya stabil tetapi juga memiliki kapasitas yang cukup untuk menangani tambahan proses jika diperlukan. Tetapi untuk rata-rata nilai disetiap waktu pada Load Average jika mengalami kondisi Bad maka mungkin baru mulai mengalami tekanan, dan penting untuk memantau apakah ini berlanjut atau hanya bersifat sementara dan sistem perlu diperiksa untuk memastikan tidak ada masalah yang berulang.";
    } else if (
      this.someFair(analysisResults) &&
      this.someWarning(analysisResults)
    ) {
      paragraphText =
        "Jika nilai rata-rata load average berada dalam Kondisi Fair menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Dalam kondisi ini, load average sudah mendekati kapasitas maksimum, sehingga sistem memiliki risiko menjadi terlalu terbebani jika ada tambahan proses yang signifikan. Tetapi, jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius.";
    } else if (
      this.someBad(analysisResults) &&
      this.someFair(analysisResults)
    ) {
      paragraphText =
        "Jika nilai rata-rata load average berada dalam Kondisi Fair menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Dalam kondisi ini, load average sudah mendekati kapasitas maksimum, sehingga sistem memiliki risiko menjadi terlalu terbebani jika ada tambahan proses yang signifikan. Tetapi, jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius. Tetapi, jika nilai rata-rata load average berada dalam kondisi Bad, ini menunjukkan bahwa sistem mengalami beban berlebih yang signifikan, di mana jumlah proses yang menunggu untuk dijalankan oleh CPU jauh melebihi kapasitas yang tersedia. Hal ini biasanya disebabkan oleh jumlah tugas yang terlalu banyak untuk ditangani secara efisien oleh CPU.";
    } else if (
      this.someBad(analysisResults) &&
      this.someWarning(analysisResults)
    ) {
      paragraphText =
        "Jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius. Tetapi, jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius. Tetapi, jika nilai rata-rata load average berada dalam kondisi Bad, ini menunjukkan bahwa sistem mengalami beban berlebih yang signifikan, di mana jumlah proses yang menunggu untuk dijalankan oleh CPU jauh melebihi kapasitas yang tersedia. Hal ini biasanya disebabkan oleh jumlah tugas yang terlalu banyak untuk ditangani secara efisien oleh CPU.";
    } else if (this.someFair(analysisResults)) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Tetapi, Jika nilai rata-rata load average berada dalam Kondisi Fair menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Dalam kondisi ini, load average sudah mendekati kapasitas maksimum, sehingga sistem memiliki risiko menjadi terlalu terbebani jika ada tambahan proses yang signifikan.";
    } else if (this.someWarning(analysisResults)) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Tetapi, Jika nilai rata-rata load average berada dalam Kondisi Fair menggambarkan sistem yang mulai mendekati batas optimalnya, tetapi masih dapat menangani beban kerja tanpa penurunan kinerja yang signifikan. Tetapi, jika nilai rata-rata load average berada dalam kondisi Warning menunjukkan bahwa system load sudah melampaui batas yang dianggap ideal untuk stabilitas sistem, tetapi belum mencapai kondisi kritis. Ini adalah tahap peringatan dini bahwa sistem mulai terbebani dan memerlukan perhatian segera untuk mencegah dampak lebih serius.";
    } else if (this.someBad(analysisResults)) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Sistem tidak hanya stabil tetapi juga memiliki kapasitas yang cukup untuk menangani tambahan proses jika diperlukan. Tetapi untuk rata-rata nilai disetiap waktu pada Load Average jika mengalami kondisi Bad maka mungkin baru mulai mengalami tekanan, dan penting untuk memantau apakah ini berlanjut atau hanya bersifat sementara dan sistem perlu diperiksa untuk memastikan tidak ada masalah yang berulang. Hal ini perlu dimonitor lebih lanjut untuk memastikan stabilitas sistem secara keseluruhan dan untuk mengantisipasi masalah lebih awal.";
    } else if (this.someIdle(analysisResults)) {
      paragraphText =
        "Secara umum, jika nilai rata-rata load average berada dalam kondisi baik, ini menunjukkan bahwa sistem berada dalam performa optimal, di mana CPU mampu menangani semua proses yang berjalan tanpa adanya antrean atau beban berlebih. Sistem tidak hanya stabil tetapi juga memiliki kapasitas yang cukup untuk menangani tambahan proses jika diperlukan.";
    }

    this.convertImageToBase64(image).then((base64Image) => {
      const doc = new Document({
        sections: [
          {
            properties: {},
            children: [
              // COVER PAGE
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.RIGHT,
                children: [
                  new ImageRun({
                    data: base64Image,
                    transformation: { width: 250, height: 50 },
                  }),
                ],
              }),

              new Paragraph({
                spacing: {
                  after: 2000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Last 6-Hour Report Maintenance",
                    font: "Arial",
                    size: 60,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 4000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "E-Office",
                    font: "Arial",
                    size: 40,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: formattedDate,
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Kementerian Investasi dan Hilirisasi/BKPM",
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Infrastructure System",
                    font: "Arial",
                    size: 20,
                    italics: true,
                  }),
                ],
              }),

              // PAGE BREAK
              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              // SECOND PAGE
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "HEALTH CHECK & UTILIZATION SUMMARY",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Last 6-Hour Average System Load",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Period Last 6 Hour",
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: `Host ${value}`,
                    font: "Arial",
                    color: "000000",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new ImageRun({
                    data: imgData,
                    transformation: { width: 650, height: 400 },
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Information :",
                    font: "Arial",
                    color: "000000",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...this.getCpuInfoParagraphs(),

              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Analysis & Condition :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...analysisParagraphs,

              new Paragraph({
                spacing: { after: 200 },
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Conclusion :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({
                    text: paragraphText,
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),
            ],
          },
        ],
      });

      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "report-maintenance-system-load-6-hour.docx");
      });
    });
  };

  allGood = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Good");
  };

  allBad = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Bad");
  };

  allFair = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Fair");
  };

  allWarning = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Warning");
  };

  someBad = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Bad");
  };

  someIdle = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Idle");
  };

  someFair = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Fair");
  };

  someWarning = (analysisResults) => {
    return analysisResults.some((result) => result.status === "Warning");
  };

  analyzeChartData = (datasets) => {
    if (!datasets || datasets.length === 0) {
      return "Data grafik tidak tersedia.";
    }

    const results = datasets.map((dataset) => {
      const average =
        dataset.data.reduce((sum, val) => sum + val, 0) / dataset.data.length;

      let status;
      if (average === 0) {
        status = "Idle";
      } else if (average < 6) {
        status = "Good";
      } else if (average < 8) {
        status = "Fair";
      } else if (average < 12) {
        status = "Warning";
      } else {
        status = "Bad";
      }

      return {
        label: dataset.label,
        average: average.toFixed(2),
        status: status,
      };
    });

    return results;
  };

  convertImageToBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      fetch(imageUrl)
        .then((res) => res.blob())
        .then((blob) => {
          reader.onloadend = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };

  getCpuInfoParagraphs = () => {
    const { data } = this.state;
    const { selectedHost } = this.props;

    if (!selectedHost || !Array.isArray(data)) return [];

    const value = selectedHost.value;
    const specificHost = data.find((item) => item.host.hostid === value);
    const graphId = specificHost ? specificHost.graph.graphid : null;
    const specificGraph = data.find((item) => item.graph.graphid === graphId);
    const items =
      specificGraph && Array.isArray(specificGraph.graph.items)
        ? specificGraph.graph.items
        : [];

    const filteredItems = items.filter(
      (item) => item.name !== "Linux: Number of CPUs"
    );

    return filteredItems.map((item, index) => {
      return new Paragraph({
        spacing: {
          after: 80,
        },
        children: [
          new TextRun({
            text: `${item.name} - `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Last:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${item.last !== null ? item.last : "0.000"}% | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Min:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${item.min !== null ? item.min : "0.000"}% | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Average:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${item.average !== null ? item.average : "0.000"}% | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Max:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${item.max !== null ? item.max : "0.000"}%`,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
        ],
      });
    });
  };

  render() {
    const { loading, errorMessage } = this.state;
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              {loading ? (
                <div className="text-center">
                  <div>
                    <Spinner
                      style={{
                        width: "3rem",
                        height: "3rem",
                        borderWidth: "0.4rem",
                      }}
                      color="dark"
                    />
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      Mengambil Data ...
                    </span>
                  </div>
                </div>
              ) : errorMessage ? (
                <Card className="text-center">
                  <br />
                  <CardBody>
                    <h5 className="text-dark">{errorMessage}</h5>
                    <br />
                    <Button color="danger" onClick={this.fetchData}>
                      Muat Ulang
                    </Button>
                  </CardBody>
                </Card>
              ) : (
                <div>
                  <div style={{ textAlign: "right" }}>
                    <Button onClick={this.handleDownloadWord} color="primary">
                      <span className="uil-cloud-download"></span> Unduh Data
                    </Button>
                  </div>
                  <br />
                  <div>
                    <Line
                      ref={(ref) => (this.chartRef = ref && ref.chartInstance)}
                      data={this.createChart()}
                      options={{
                        responsive: true,
                        plugins: {
                          legend: {
                            position: "top",
                          },
                          tooltip: {
                            callbacks: {
                              label: function (context) {
                                return context.raw + "%";
                              },
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <hr />
            <Col className="col-12">{this.renderSystemLoadInfo()}</Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
